import React from 'react';

import Carousel from '@hpstellar/core/Carousel';

import { Helpers } from '../../core/src/helpers';
import ModalFooterV2 from './modal-footer-v2';
import CartQuantityIndicator from './cart-quantity-indicator';
import TabsV2Summary from './tabs-v2-summary-section';
import XsellProductV2 from './xsell-product-v2';
import { getTabsModalCategories } from '../xsell-actions';
import ModalHeaderV2 from './modal-header-v2';
import withWindowResize from '../../ui/components/window-resize';



import '../css/tabs-xsell-v2.less';

class TabsXSellModalV2 extends React.Component {

    constructor(props) {
        super(props);

        let { xSellProductList, product } = this.props;
        let categories = getTabsModalCategories(xSellProductList, product);
        this.state = {
            activeTab: 'Most Popular',
            skusAdded: [],
            categories
        }
    }

    closeModal = () => {
    	this.props.closeXSellModal();
    }

    handleAddandRemove = (action, sku) => {
        if (action === 'add') {
            this.setState({
                skusAdded: [...this.state.skusAdded, sku]
            })
        } else if (action === 'remove') {
            this.setState({
                skusAdded: this.state.skusAdded.filter((prodSku) => prodSku !== sku)
            })
        }
    }

    changeTab = (tabName) => {
        this.setState({ activeTab: tabName })
    }

    controls(type, quantity) {
        if (type === 'category') {
            return {
                slidesToShow: 6,
                slidesToScroll: 6,
                infinite: false,
                responsive: [{
                        breakpoint: 950,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                          slidesToShow: 4,
                          slidesToScroll: 2
                        }
                    },
                    {
                      breakpoint: 620,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    }
                ]
            }
        } else if (type === 'product') {
            return {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: quantity >= 3 ? true : false,
                centerPadding: '10%',
                centerMode: quantity >= 3 ? true : false,
                responsive: [{
                        breakpoint: 950,
                        settings: {
                            centerMode: false,
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        centerMode: false,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true
                      }
                    }
                ]
            }
        }
    }

    render() {
        const { product, closeModal, device, ctaMetrics, getProductClickMetrics, baseProductSku, xsellType } = this.props;
        const { categories, activeTab, skusAdded } = this.state;
        const { name, isSmb, sku } = product;
        const isProductPC = Helpers.isProductPC(product);
        const catSettings = {
            ...this.controls('category'),
        };
        const prodSettings = {
            ...this.controls('product', ((categories[activeTab] || {}).products || []).length),
        };

        const content = Object.keys(categories).length > 0 && categories.constructor === Object ?
        <div>
            <CartQuantityIndicator device={device} />
            { device === 'mobile' && <ModalHeaderV2 productInfo={product} device={device}/> }
            { device === 'mobile' && <h3 className='subtitle'>Add accessories to your product</h3> }
            <div className='modal-content-wrapper'>
                <div className='products-section'>
                    <div className={`header${isProductPC ? ' pc' : ''}${isSmb ? ' business' : 'consumer'}`}>Frequently bought together</div>
                    <div className='tabs-v2-category-list'>
                        <Carousel 
                            className='xsell-category-carousel'
                            prevArrowClassName='xsell-cats-prev' 
                            nextArrowClassName='xsell-cats-next' 
                            {...catSettings}
                        >
                            {(Object.keys(categories) || []).map((category, i) => {
                                return (
                                <div className={category === activeTab ? 'active-tab tab' : 'tab'} key={i} onClick={() => this.changeTab(category)}>
                                    <span>{category}</span>
                                    <div className='border'></div>
                                </div>
                                )
                            })}
                        </Carousel>
                    </div>
                    <div className="tabs-v2-xsell-products">
                        <Carousel 
                            className='xsell-category-carousel' 
                            prevArrowClassName='xsell-prds-prev' 
                            nextArrowClassName='xsell-prds-next' 
                            {...prodSettings}
                        >
                            {((categories[activeTab] || {}).products || []).slice(0, 6).map((prod, i) => {
                                return <XsellProductV2
                                            key={i}
                                            className='tabs-v2'
                                            product={prod}
                                            xsellTemplate={'tabs'}
                                            handleAddandRemove={this.handleAddandRemove}
                                            added={skusAdded.indexOf(prod.sku) > -1}
                                            productClickMetrics={typeof getProductClickMetrics === 'function' ? getProductClickMetrics({product: prod, position: i+1 }) : null}
                                            ctaMetrics={ctaMetrics}
                                            baseProductSku={baseProductSku}
                                            xsellType={xsellType}
                                        />
                            })}
                        </Carousel>
                    </div>
                </div>
                <TabsV2Summary productInfo={product} device={device} isProductPC={isProductPC} isSmb={isSmb} />
            </div>
            <ModalFooterV2 
                closeModal={closeModal}
                device={device}
            />
        </div> : null;
        return content;
    }
};

export default withWindowResize(TabsXSellModalV2);
